import {Component, OnInit, ViewChild} from '@angular/core';
import 'brace';
import 'brace/mode/csharp';
import 'brace/mode/typescript';
import 'brace/theme/xcode';
import {AceComponent, AceConfigInterface, AceDirective} from 'ngx-ace-wrapper';
import {BaseModalComponent} from 'common-shared';
import {ExpressionModel} from '../../expression.model';
import ExcelFormula from '@leanest/excel-formula'

@Component({
  selector: 'app-expression-formula-editor',
  templateUrl: './expression-formula-editor.component.html',
  styles: []
})
export class ExpressionFormulaEditorComponent extends BaseModalComponent implements OnInit {
  expression: ExpressionModel;
  hasExternalFormula: boolean;
  currentTab: 'formula' | 'externalFormula' | 'comments' = 'formula';
  readonly: boolean;

  public config: AceConfigInterface = {
    mode: 'typescript',
    theme: 'xcode',
    readOnly: false,
    showLineNumbers: false,
    showGutter: true,
    showPrintMargin: false,
    cursorStyle: 'wide',
    enableBasicAutocompletion: true,
    fontSize: 24,
    highlightActiveLine: false,
    highlightSelectedWord: false,
    useSoftTabs: true,
    wrap: true,
    displayIndentGuides: true
  };

  @ViewChild('formulaEditor') formulaEditorRef?: AceComponent;
  @ViewChild('externalFormulaEditor') externalFormulaEditorRef?: AceComponent;
  @ViewChild('commentsEditor') commentsEditorRef?: AceComponent;
  showFindAndReplace = false;

  constructor() {
    super();
    this.config["indentedSoftWrap"] = false;
  }

  ngOnInit() {
  }

  beautify() {
    if (this.currentTab === 'formula') {
      this.expression.Formula = this.format(this.expression.Formula);
    } else if (this.currentTab === 'externalFormula') {
      this.expression.ExternalFormula = this.format(this.expression.ExternalFormula);
    } else if (this.currentTab === 'comments') {
      this.expression.Comments = this.format(this.expression.Comments);
    }
  }

  private format(formula: string): string {
    const emptyRow = new RegExp(/\n\s*\n/g);
    const whitespaceBetweenAmpersands = new RegExp(/&\s+&/g);
    const whitespaceBetweenEquals = new RegExp(/=\s+=/g);
    const numberArrayStart = new RegExp(/\w\(\s\d+/g);
    const stringArrayStart = new RegExp(/\w\(\s'?\w+/g);
    const commentStart = 'COMMENTSTART';
    const commentEnd = 'COMMENTEND';
    const commentBlock = 'COMMENTBLOCK';
    let comments = [];

    formula = formula.replace(/\/\*/g, commentStart)
      .replace(/\*\//g, commentEnd);

    while (formula.includes(commentStart) && formula.includes(commentEnd)) {
      const startIndex = formula.indexOf(commentStart);
      const endIndex = formula.indexOf(commentEnd) + commentEnd.length;
      const comment = formula.substring(startIndex, endIndex);
      comments.push(comment);
      formula = formula.replace(comment, commentBlock);
    }

    const formattingOptions = {
      tmplIndentTab: '  ',
      tmplFunctionStart: '{{autoindent}}{{token}}({{autolinebreak}}',
      tmplFunctionStop: '{{token}})',
      tmplArgument: '{{token}}{{autolinebreak}}',
      autoLineBreak: 'TOK_TYPE_FUNCTION | TOK_SUBTYPE_LOGICAL | TOK_TYPE_OP_IN ',
      customTokenRender: function (tokenString, token, indent, lineBreak, lastToken) {
        const result = {tokenString: tokenString, useTemplate: true, token: token, indent: indent, lineBreak: lineBreak, lastToken: lastToken};
        console.log(result);

        if(token.type == 'function' && token.subtype == 'stop' && lastToken.value == '\n'){
          result.tokenString = indent;
        }

        return result;
      }

    }

    console.table(ExcelFormula.getTokens(formula));
    formula = ExcelFormula.formatFormula(formula, formattingOptions);
    formula = formula.replace(whitespaceBetweenAmpersands, '&&')
      .replace(whitespaceBetweenEquals, '==')
      .replace(emptyRow, '\n')
      .replace(stringArrayStart, this.replacer)
      .replace(numberArrayStart, this.replacer)

    while (comments.length) {
      formula = formula.replace(commentBlock, comments.shift());
    }

    return formula.replace(/COMMENTSTART/g, '/*')
      .replace(/COMMENTEND/g, '*/');
  }

  replacer(match) {
    return match.replace(/\s/, '');
  }

  find(needle: string) {
    let editor = this.getActiveEditor();
    editor.ace().find('');
    editor.ace().find(needle, {backwards: false});
  }

  findPrevious() {
    let editor = this.getActiveEditor();
    editor.ace().findPrevious({backwards: true});
  }

  findNext() {
    let editor = this.getActiveEditor();
    editor.ace().findNext({backwards: false});
  }

  replace(replacement: string, needle: string) {
    let editor = this.getActiveEditor();
    editor.ace().replace(replacement);
    this.find(needle);
  }

  replaceAll(replacement: string) {
    let editor = this.getActiveEditor();
    editor.ace().replaceAll(replacement);
  }

  private getActiveEditor(): AceDirective {
    let aceComponent;
    switch (this.currentTab) {
      case 'formula': {
        aceComponent = this.formulaEditorRef;
        break;
      }
      case 'externalFormula': {
        aceComponent = this.externalFormulaEditorRef;
        break;
      }
      case 'comments': {
        aceComponent = this.commentsEditorRef;
        break;
      }
      default:
        console.error('Editor not found');
        return;
    }
    return aceComponent.directiveRef;
  }
}
